<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>テンプレート編集</strong>
          </CCardHeader>
          <CCardBody>
            <CForm class="member-info">
              <CRow>
                <CCol lg="10" class="py-2">
                  <h4 class="sub-title">プレビュー</h4>
                  <p class="template_preview" v-html="vhtml"></p>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <!-- <CInput label="テースト承認" horizontal /> -->
                  <CButton
                    color="info"
                    class="ml-0 px-4"
                    v-on:click="checkTemplaate()"
                    > テンプレート承認
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter>
            <CButton color="secondary" class="ml-0 px-5" v-on:click="goBack()"
              ><i class="icon cil-arrow-left"></i> 戻る
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- start_completeModal -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  name: "テンプレート編集",
  data() {
    return {};
  },
  //入力項目にvalidation
  validations: {
    application: {
      summary: {
        required,
        maxLength: maxLength(100),
      },
      description: {
        required,
        maxLength: maxLength(1000),
      },
    },
  },
  beforeMount() {},
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.push({ name: "配信テンプレート" });
    },
  },
};
</script>
